export default {
    "de": {
        "jobs": {
            "common": {
                "technician_request_send": {
                    "title": "Anfrage erhalten",
                    "introtext": "Neue Anfrage von {trigger_user.name} erhalten.",
                    "text_label": "Nachricht:"
                },
                "technician_message_checks": {
                    "title": "Checks"
                },
                "technician_message_fittings": {
                    "title": "Beschlägeliste"
                },
                'job_close_cancelled': {
                    "title": "Abgebrochen"
                },
                'job_close_finished': {
                    "title": "Abgeschlossen"
                },
                "job_close_unfinished": {
                    "title": "Unvollständig abgeschlossen"
                },
                "technician_message_common": {
                    "title": "Allgemeine Meldung"
                },
                "job_close_without_text": {
                    "title": "Montage abgeschlossen",
                    "service_title": "Service abgeschlossen",
                }
            }
        }
    }
}